//
////
//if (typeof autoComplete === 'undefined') {
//    return;
//}
//
////
//const sessionStorage = require('../utils/sessionStorage.js');
//const zenoFetch      = require('../utils/zenoFetch.js');
//const createElement  = require('../utils/createElement.js');
//
////
//document.querySelectorAll('input[name="search"][data-autocomplete]').forEach((input, index) => {
//
//    //
//    input.setAttribute('id', `search-input-${index}`)
//
//    //
//    const autoCompleteJS = new autoComplete({
//
//        //
//        'selector': `input[name="search"][data-autocomplete]#search-input-${index}`,
//
//        //
//        'submit': true,
//
//        //
//        'data': {
//            'src': async function () {
//
//                //
//                const cachedOptions = sessionStorage.get('nrla-search-autocomplete');
//                if (cachedOptions !== null) {
//                    return cachedOptions;
//                }
//
//                //
//                const [status, options] = await zenoFetch('get', '/api/search-autocomplete');
//
//                //
//                if (status == 'success') {
//                    sessionStorage.set('nrla-search-autocomplete', options);
//                    return options;
//                }
//
//                //
//                return [];
//
//            },
//            'cache': true,
//        },
//
//        //
//        'resultsList': {
//            'element': (list, data) => {
//                const searchSuggestion = createElement('div', { 'class' : 'search-suggestion' });
//                searchSuggestion.append(createElement('span', {}, `Search for “${data.query}”`));
//                list.prepend(searchSuggestion);
//            },
//        },
//
//        //
//        'resultItem': {
//            'highlight': true
//        },
//
//        //
//        'events': {
//            'input': {
//                'selection': (event) => {
//                    autoCompleteJS.input.value = event.detail.selection.value;
//                    autoCompleteJS.input.closest('form').submit();
//                }
//            }
//        }
//
//    });
//});
